import envVars from "@/helpers/Env";
import { i18n } from "@/i18n";
import { computed } from "vue";

export default function useTermsLinks() {
  const publicPath = envVars.baseUrl ?? "/";

  /**
   * Links are always in english, except if the language is set to german
   */
  const links = computed(() => {
    const baseLink = `${publicPath}files`;
    if (i18n.locale.value !== "de") {
      return {
        agb: `${baseLink}/AGB-en.pdf`,
        terms: `${baseLink}/terms-en.pdf`,
        privacy: `${baseLink}/privacy-en.pdf`
      };
    }
    return {
      agb: `${baseLink}/AGB.pdf`,
      terms: `${baseLink}/terms.pdf`,
      privacy: `${baseLink}/privacy.pdf`
    };
  });

  return {
    links
  };
}
